<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import LeResultsListButton from "@/components/dictionary-selector/LeResultsListButton.vue";
import { SearchRouteHelper } from "@/helpers";
import { useUserStore } from "@/stores";

const props = defineProps<{ isSelected: boolean }>();

const { t } = useI18n();

const searchRouteHelper = new SearchRouteHelper(useRouter(), useUserStore().userData);
</script>

<template>
  <LeResultsListButton
    class="le-dictionary-deselector"
    :is-selected="props.isSelected"
    :route="searchRouteHelper.generateResetSearchUrl()"
    @click="searchRouteHelper.deselectDictionary()"
  >
    <template #content>
      <span class="le-dictionary-deselector__text">
        {{ t("le-dictionary-selector.deselector-button") }}
      </span>
    </template>
  </LeResultsListButton>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-dictionary-deselector {
  height: 58px;
  border-radius: 4px;
  box-shadow: @shadows[button];
  .body-text("s", "semi-bold");

  &__text {
    display: flex;
    align-items: center;
    height: 100%;
  }
}
</style>
